import { useEffect } from "react";
import Modal from "../base/Modal";
import Icon from "../base/Icon";


// Forced, non-dismissable modal shown to Dispatchers/Technicians whose account owner is limited.
// Unlike ModalLimited (Admin/Customer), it has no Subscribe button and cannot be closed — it clears
// only when the account is un-limited (AccountUnlimited socket event) or on the next login attempt.
function ModalAccountRestricted() {

    useEffect(() => {
        window.openModal("modal-account-restricted");
    }, [])

    return (
        <Modal id="modal-account-restricted"
            title="Account Restricted"
            staticBackdrop preventDiscard noFooter>
            <div className="text-center py-8">
                <Icon icon="lock" size={44} className="text-danger mb-5" />
                <p className="text-danger fs-5 mb-0">
                    This account has been restricted.
                </p>
                <p className="text-gray-700 mt-2">
                    Please contact your department manager.
                </p>
            </div>
        </Modal>
    )
}

export default ModalAccountRestricted;
